import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

function Footer() {
  const { t } = useApp();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="glass-effect mt-16 border-t border-gray-200 dark:border-gray-800">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Informações da Empresa */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('footer.company.title')}
            </h3>
            <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
              <p><strong>{t('footer.company.name')}:</strong></p>
              <p>61.458.294 THIAGO HENRIQUE SILVA ALVES</p>
              <p><strong>{t('footer.company.cnpj')}:</strong> 61.458.294/0001-94</p>
              <p><strong>{t('footer.company.address')}:</strong></p>
              <p>Rua Fernão Dias, 3804</p>
              <p>Belo Horizonte - MG - CEP 30285-160</p>
            </div>
          </div>

          {/* Links Legais */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('footer.legal.title')}
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link 
                  to="/privacy" 
                  className="text-gray-600 dark:text-gray-400 hover:text-primary-light dark:hover:text-primary-dark transition-colors"
                >
                  {t('footer.legal.privacy')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms" 
                  className="text-gray-600 dark:text-gray-400 hover:text-primary-light dark:hover:text-primary-dark transition-colors"
                >
                  {t('footer.legal.terms')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-gray-600 dark:text-gray-400 hover:text-primary-light dark:hover:text-primary-dark transition-colors"
                >
                  {t('footer.legal.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Redes Sociais e Contato */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('footer.contact.title')}
            </h3>
            <div className="space-y-3 text-sm text-gray-600 dark:text-gray-400">
              <p>
                <strong>{t('footer.contact.email')}:</strong>
                <br />
                <a href="mailto:thiago@thz.dev.br" className="hover:text-primary-light dark:hover:text-primary-dark transition-colors">
                  thiago@thz.dev.br
                </a>
              </p>
              <p>
                <strong>{t('footer.contact.phone')}:</strong>
                <br />
                <a href="tel:+5531983965539" className="hover:text-primary-light dark:hover:text-primary-dark transition-colors">
                  +55 (31) 98396-5539
                </a>
              </p>
              <div className="flex space-x-4 pt-2">
                <a
                  href="https://github.com/devthz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 dark:text-gray-400 hover:text-primary-light dark:hover:text-primary-dark transition-colors"
                  aria-label="GitHub"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                  </svg>
                </a>
                <a
                  href="https://linkedin.com/in/thiagohsa22"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 dark:text-gray-400 hover:text-primary-light dark:hover:text-primary-dark transition-colors"
                  aria-label="LinkedIn"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-.88-.016-2.005-1.22-2.005-1.22 0-1.405.953-1.405 1.94v5.669h-3v-11h2.84v1.58h.04c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.865z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-800 text-center text-sm text-gray-600 dark:text-gray-400">
          <p>© {currentYear} Thiago Henrique Silva Alves. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
